import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/terms")({
  head: () => ({
    meta: [
      { title: "Terms of Use — Quibblies" },
      {
        name: "description",
        content:
          "The terms that govern your Quibblies account: eligibility, content ownership, moderation rights, creator support and account termination.",
      },
      { property: "og:title", content: "Terms of Use — Quibblies" },
      {
        property: "og:description",
        content: "Account, content and moderation terms for Quibblies members.",
      },
      { property: "og:type", content: "article" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: TermsPage,
});

const SECTIONS = [
  {
    title: "1. Eligibility",
    body: "You must be 18 or older to hold a Quibblies account. By registering you confirm your age and accept these terms and our Community Guidelines.",
  },
  {
    title: "1a. Proof of age",
    body: "If we have reason to doubt that an account holder is 18 or over, we may ask you to upload a photo of a government-issued ID as proof of age. Those images are visible to Administrators and the Owner only — never to moderators, other members or the public — are used solely to confirm your age, and are deleted once the check is complete. Accounts that decline a proof-of-age request may be suspended.",
  },

  {
    title: "2. Your content stays yours",
    body: "You keep full copyright in everything you publish. By publishing on Quibblies you grant us a non-exclusive licence to host, display and distribute the work on the platform.",
  },
  {
    title: "3. Review and removal",
    body: "All submissions are reviewed before publication. We may request changes, reject a submission, or remove published work that breaches these terms or our guidelines.",
  },
  {
    title: "4. Accounts and conduct",
    body: "You are responsible for activity on your account. Warnings, suspensions and bans may be applied where conduct breaches our rules.",
  },
  {
    title: "5. Creator support",
    body: "Tips to authors are voluntary and non-refundable except where required by law. Quibblies is not party to any agreement between a reader and an author.",
  },
  {
    title: "6. Changes",
    body: "We may update these terms. Material changes are announced in-app before they take effect, and continued use constitutes acceptance.",
  },
];

function TermsPage() {
  return (
    <article className="mx-auto max-w-3xl px-4 py-14 sm:px-6">
      <h1 className="font-display text-4xl text-foreground">Terms of Use</h1>
      <p className="mt-3 text-muted-foreground">
        Plain-language terms for members, authors and readers.
      </p>
      <div className="mt-10 space-y-8">
        {SECTIONS.map((section) => (
          <section key={section.title}>
            <h2 className="font-display text-xl text-foreground">{section.title}</h2>
            <p className="mt-2 leading-relaxed text-muted-foreground">{section.body}</p>
          </section>
        ))}
      </div>
    </article>
  );
}
